<template>
	<el-card>
        <div slot="header">
            <span class="top_title">商品出库</span>
        </div>
        <div class="searchItem">
            <div class="search">
                <span style="padding-right:10px">日期:</span>
                <el-date-picker
                    v-model="date"
                    type="datetime"
                    placeholder="日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    style="width: 180px;padding-right:10px"
                />
            </div>
            <div class="search">
                <span style="padding-right:10px">出库类型:</span>
                <el-select v-model="oper" style="width:180px">
                    <el-option value="其他出库" label="其他出库"></el-option>
                    <el-option value="销售出库" label="销售出库" v-if="$common.hasLimits('stockOutSend')"></el-option>
                </el-select>
            </div>
            <div style="padding-right:10px">
                <Customer :orderForm="search" :hideStar='true'></Customer>
            </div>
        </div>
		<SPTable ref="spt" :cols='cols' :structure="structure" @returnData="saveExit"></SPTable>
		<div class="rootbtn">
            <el-button type="primary" @click="getData" :loading="lock">确认</el-button>
		</div>
	</el-card>
</template>

<script>

import SPTable from  "../../components/table-column/supertable";
import Customer from  "../../components/customer";
export default {
    components: {SPTable,Customer},
    data() {
        return {
            cols: [
                {
                    prop: "name",
                    label: "商品",
                    edit:'productEdit',
                    type: "productEdit",
                    width: 240,
                },
                {
                    prop: "spec",
                    label: "规格",
                    edit:'',
                    type: "",
                    width: 130,
                },
                {
                    prop: "store",
                    label: "仓库",
                    edit:'whEdit',
                    type: "whEdit",
                    width: 130,
                    showName:'storename',
                    main:1,
                },
                {
                    prop: "stock",
                    label: "库存",
                    edit:'',
                    type: "stockEdit",
                    width: 130,
                },
                {
                    prop: "count",
                    label: "数量("+this.$global.pack+")",
                    edit:'countEdit',
                    type: "countEdit",
                    width: 130,
                    unit:this.$global.pack,
                    hide:this.$global.buyType==2?true:false,
                },
                {
                    prop: "num",
                    label: "数量("+this.$global.unit+")",
                    edit:'numEdit',
                    type: "countEdit",
                    width: 130,
                    unit:this.$global.unit,
                    hide:this.$global.buyType==1?true:false,
                },
                {
                    prop: "price",
                    label: "价格(元)",
                    edit:'',
                    type: "",
                    width: 130,
                },
                {
                    prop: "unit",
                    label: "单位",
                    edit:'',
                    type: "unitEdit",
                    width: 130,
                },
                {
                    prop: "remark",
                    label: "备注",
                    edit:'remarkEdit',
                    type: "remarkEdit",
                    min_width: 200,
                    align: "center",
                },
            ],
            date: this.$common.format(new Date()),
            oper: this.$common.hasLimits('stockOutSend')?'销售出库':'其他出库',
            search:{
                cid:'',
                cname:'',
            },
            lock:false,
        }
    },
    methods: {
        structure(){
            let obj = {
                id:0,
                pid: '',
                spid:'',
                spec:'',
                price: 0,
                unit: 0,
                store: '',
                enterstore:'',
                storename:'',
                stock: '',
                stDesc:'',
                negative:'',
                count: 0,
                name:'',
                number:'',
                needsend:0,
                num:0,
                remark:'',
                stockList:{},
                productEdit:false,
                whEdit:false,
                countEdit:false,
                numEdit:false,
                remarkEdit:false,
            }
            return obj;
        },
        getData(){
            this.lock = true;
            this.$refs.spt.getData();
        },
        saveExit(formData) {
            let obj = {
                date:this.date,
                oper:this.oper,
            }
            if(this.search.cid>0){
                obj.cid = this.search.cid;
            }
            if(this.oper=="销售出库"){
                obj.generateSend = 1;
                if((!obj.cid)||obj.cid<1){
                    this.$common.error('销售发货必须选择客户');
                    this.lock = false;
                    return;
                }
            }
            let detail = [];
            formData.forEach(e=>{
                let outnumber = e.count*e.unit+e.num;
                let existnumber = 0;
                if(e.pid>0&&outnumber>0){
                    let st = e.stockList[e.store];
                    if(st!=null){
                        if(st.negative==0){
                            existnumber = st.stock;
                        }else{
                            existnumber = 2147483647;
                        }
                    }else{
                        existnumber = 0;
                    }
                    if(outnumber<existnumber){
                        let obj1 = {
                            pid:e.pid,
                            spid:e.spid,
                            pro:e.number+"_"+e.name,
                            wid:e.store,
                            price:e.price,
                            spec:e.spec,
                            pack:e.count,
                            unit:e.unit,
                            small:e.num,
                            remark:e.remark,
                            amount:outnumber,
                        }
                        detail.push(obj1);
                    }
                }
            })
            if(detail.length>0){
                obj.detail = JSON.stringify(detail);
                this.$api.addOutboundRecord(obj).then(res=>{
                    if(res.data.code==1){
                        this.$notify({
                            title: "商品出库",
                            message: "出库成功",
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.$router.push("/storeDetail");
                            },
                        })
                    }else{
                        this.$common.error(res.data.msg);
                    }
                })
            }else{
                this.$common.error("没有可出库数据");
                this.lock = false;
            }
        },
    },
}
</script>